import React, { useState } from 'react'
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormCSS from "../../../common/form/fom.module.scss";
import TypoCss from "../../../text/typography.module.scss";

function CreditCardElement() {
  const { t } = useTranslation();
  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext();

  const [card, setCard] = useState("");

  const formatCardNumber = (value) => {
    // Remove non-digits and add space every 4 digits
    const raw = value.replace(/\D/g, '');
    const formatted = raw.match(/.{1,4}/g)?.join(' ') ?? raw;
    return formatted;
  };

  const handleChange = (e) => {
    const input = e.target.value;
    const formatted = formatCardNumber(input);
    setCard(formatted);
    setValue("cardNumber", formatted); // Update react-hook-form
  };

  return (
    <>
      <label htmlFor="cardNumber" className={TypoCss.tabclix__label}>
        {t("card_number")}
      </label>
      <input
        type="text"
        id="cardNumber"
        className={`${FormCSS.tabclix_input_field} ${FormCSS.tabclix__w_input}`}
        maxLength={19}
        value={card}
        onChange={handleChange}
      />
      <p className={FormCSS.error_form_message}>
        {errors.cardNumber?.message}
      </p>
    </>
  );
}

export default CreditCardElement;
